




/* istanbul ignore file */
import { defineComponent, PropType } from '@nuxtjs/composition-api';

import { Mark } from '../../constants';
import { MarkNode } from '../../types';

export default defineComponent({
  name: 'SbText',
  props: {
    text: {
      type: String,
      required: true,
    },
    marks: {
      type: Array as PropType<MarkNode[]>,
      required: true,
    },
  },
  data() {
    return {
      Mark,
    };
  },
  computed: {
    textClass(): string[] {
      let textClass = ['sb-text'];
      this.marks.forEach((mark) => {
        switch (mark.type) {
          case Mark.BOLD:
            textClass.push('sb-text--bold');
            break;
          case Mark.STRONG:
            textClass.push('sb-text--strong');
            break;
          case Mark.STRIKE:
            textClass.push('sb-text--strike');
            break;
          case Mark.UNDERLINE:
            textClass.push('sb-text--underline');
            break;
          case Mark.ITALIC:
            textClass.push('sb-text--italic');
            break;
        }
      });
      return textClass;
    },
  },
});
